import React from 'react'

import {Base64FileAttachment} from './base64-file-attachment'

export function useCreateAttachment() {
  return React.useCallback((file: File) => {
    const attachment = new Base64FileAttachment(file)

    attachment.prefetch()

    return attachment
  }, [])
}
